function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0174 20H13.9759C13.9759 21.1 13.0862 22 11.9967 22C10.9071 22 10.0174 21.1 10.0174 20ZM20.0836 17.5L18.1743 14.55V10.58C18.1743 7.41 15.9252 4.78 12.9863 4.29V2H11.007V4.27C9.8175 4.47 8.7479 5.04 7.88823 5.84L9.30769 7.27C10.0374 6.63 10.9671 6.23 11.9967 6.23C14.3058 6.23 16.1951 8.17 16.1951 10.56V14.22L20.2235 18.29C20.2835 18.02 20.2435 17.73 20.0836 17.49V17.5ZM4.64947 5.38L19.6837 20.57L18.2843 21.98L15.4154 19.09H4.72944C4.35958 19.09 4.0297 18.88 3.85977 18.55C3.68983 18.22 3.70982 17.81 3.90975 17.5L5.81902 14.55V10.58C5.81902 10.21 5.859 9.85 5.91898 9.5L3.25 6.79L4.64947 5.38ZM6.57873 17.04H13.3961L7.79827 11.38V14.85C7.79827 15.05 7.73829 15.25 7.62833 15.42L6.57873 17.04Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=BellOff.js.map